import { useEffect, useState } from "react";
import Loader from "react-loader-spinner";

function ConfirmTransfer({
  handleChangeTransferDetails,
  transferDetails,
  bankName,
  isProcessing,
  onConfirm,
}) {
  const [areFieldsSet, setAreFieldsSet] = useState(false);

  useEffect(() => {
    const { transaction_pin, ...fields } = transferDetails;
    const isTransactionPinValid = /^\d{6}$/.test(transferDetails.transaction_pin);
    const areFieldsValid = Object.values(fields).every((value) => value !== "");
    setAreFieldsSet(isTransactionPinValid && areFieldsValid);
  }, [transferDetails]);
  

  return (
    <>
      <h2 className="mb-5 text-primary fw-bold">Confirm Electricity Purchase</h2>
      <div className="card shadow h-100 py-2">
        <div className="card-body">
          <h3 className="card-title text-muted">Confirm Purchase</h3>
          <form onSubmit={onConfirm}>
            <div className="form-group mb-3">
              <label className="form-label">From Wallet</label>
              <input
                type="text"
                className="form-control"
                value={`${transferDetails.wallet_name} (${transferDetails.wallet_account_number})`}
                disabled
                readOnly
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Meter Account Details</label>
              <input
                type="text"
                className="form-control"
                value={`${transferDetails.meter_number} | ${transferDetails.account_details} | ${transferDetails.phone_number}`}
                disabled
                readOnly
              />
            </div>
            <div className="form-group mb-3">
              <label className="form-label">Amount &#8358;</label>
              <input
                type="text"
                className="form-control"
                value={transferDetails.amount}
                disabled
                readOnly
              />
            </div>

            <hr />
            <p className="text-muted">
              To confirm this transaction, provide your transaction PIN below.
            </p>

            <div className="form-group mb-5">
              <label className="form-label" htmlFor="transactionPin">
                Transaction PIN
              </label>

              <input
                type="password"
                name="transaction_pin"
                id="transactionPin"
                className="form-control"
                placeholder=""
                title="Numbers only"
                maxLength="6"
                pattern="[0-9]{6}"
                required
                onChange={handleChangeTransferDetails}
              />
            </div>
            <button
              className={`btn w-100 btn-primary lift ${
                areFieldsSet ? "" : "disabled"
              }`}
              type="submit"
              disabled={!areFieldsSet || isProcessing}
            >
              {isProcessing ? (
                <Loader type="Oval" color="#fff" width={20} height={20} />
              ) : (
                "Next"
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default ConfirmTransfer;
